'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getOwnPropertyNames = require('babel-runtime/core-js/object/get-own-property-names');

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

exports.default = extendObservableObj;

var _mobx = require('mobx');

var _cloner = require('cloner');

var _traverse = require('traverse');

var _traverse2 = _interopRequireDefault(_traverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extendObservableObj(cls, name, desc) {
  return (0, _mobx.observable)(cls, name, {
    enumerable: true,
    writable: true,
    configurable: false,
    initializer: function initializer() {
      var _this = this;

      var src = desc.initializer.call(this);
      var target = (0, _mobx.toJS)(this[name]);
      //@TODO make recursive, this is only 1 layer deep.
      this[name].$mobx && (0, _getOwnPropertyNames2.default)(this[name]).forEach(function (k) {
        var prop = (0, _getOwnPropertyDescriptor2.default)(src, k);
        var hasGetSet = prop && (prop.get || prop.set);

        if (!hasGetSet && (0, _mobx.isObservable)(_this[name], k) && (0, _mobx.isComputed)(_this[name], k)) {
          (0, _defineProperty2.default)(target, k, {
            enumerable: true,
            get: _this[name].$mobx.values[k].derivation,
            set: _this[name].$mobx.values[k].setter
          });
        }
      });

      return _cloner.deep.merge(target, src);
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/extend-observable-decorator/dist/extend-observable-decorator.js
// module id = ./node_modules/extend-observable-decorator/dist/extend-observable-decorator.js
// module chunks = 0